var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeMobile2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 96 116",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M91.6807 66.1492C109.264 115.506 59.8499 118.681 32.9451 114.098C-23.2062 105.669 3.00951 40.6254 34.9622 12.5204C66.915 -15.5847 69.7017 4.45292 91.6807 66.1492Z",
  fill: "current"
})));
export default SvgShapeMobile2;